'use es6';

const HUBDB_REGEX = /hubdb-(\w+)-(\d+)-(\d+)/;
function getAnalyticsPageId(analyticsId, pathname) {
  if (HUBDB_REGEX.test(pathname)) {
    return HUBDB_REGEX.exec(pathname)[0];
  }
  return analyticsId;
}
export default getAnalyticsPageId;